import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { Provider } from 'react-redux';
import { getEventBusIfDefined } from '@cian/event-bus';
import { setPanoramaActiveAction } from '../../actions/map';
import { setMVKPhaseAction, toggleRouteUpdateAction, setSectionIdAction, setFloorFilterAction, setHouseIdAction } from '../../actions/mvk_state';
import { NewbuildingMVKContainer } from '../../containers/newbuilding_mvk';
import { defaultMVKState } from '../../reducers/mvk_state';
import { MVKPhase } from '../../types/mvk_state';
import { generateInitialState } from '../../utils/mvk_state';
import { createAppStore } from '../../utils/store';
import { getSectionByOfferId, getHouseBySectionId } from '../../utils/parsers/sections';
import { jsx as _jsx } from "react/jsx-runtime";
export var NewbuildingMVKWidget = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NewbuildingMVKWidget, _React$PureComponent);
  var _super = _createSuper(NewbuildingMVKWidget);
  /* eslint-disable-line @typescript-eslint/no-explicit-any */

  function NewbuildingMVKWidget(props) {
    var _this;
    _classCallCheck(this, NewbuildingMVKWidget);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "store", void 0);
    var MVKData = props.MVKData,
      queryString = props.queryString,
      usePlace = props.usePlace,
      httpApi = props.httpApi,
      logger = props.logger,
      sectionId = props.sectionId,
      offerId = props.offerId,
      subdomain = props.subdomain,
      withInfrastructure = props.withInfrastructure,
      mapApiKey = props.mapApiKey;
    var initialState = {
      MVKData: MVKData,
      MVKState: generateInitialState(defaultMVKState, queryString, usePlace),
      withInfrastructure: withInfrastructure,
      mapApiKey: mapApiKey
    };
    var storeContext = {
      httpApi: httpApi,
      logger: logger,
      subdomain: subdomain
    };
    _this.store = createAppStore(initialState, storeContext);
    if (sectionId) {
      var house = getHouseBySectionId(MVKData, sectionId);
      if (house) {
        _this.store.dispatch(setHouseIdAction(house.id));
        _this.store.dispatch(setSectionIdAction(sectionId));
      }
    } else if (offerId) {
      var section = getSectionByOfferId(MVKData, offerId);
      var offer = MVKData.offers.find(function (o) {
        return o.id === offerId;
      });
      if (section && offer) {
        _this.store.dispatch(setHouseIdAction(offer.houseId));
        _this.store.dispatch(setSectionIdAction(section.id));
        _this.store.dispatch(setFloorFilterAction(offer.floor));
      }
    }
    return _this;
  }
  _createClass(NewbuildingMVKWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var eventBus = getEventBusIfDefined();
      if (eventBus) {
        // Ловим внешние события
        eventBus.subscribe('open-panorama', function () {
          var _this2$store$getState = _this2.store.getState(),
            isPanoramaActive = _this2$store$getState.MVKState.map.isPanoramaActive;
          // Если панорама уже открыта, то игнорируем событие
          if (!isPanoramaActive) {
            _this2.store.dispatch(setMVKPhaseAction(MVKPhase.PREVIEW));
            _this2.store.dispatch(setPanoramaActiveAction(true));
          }
        });
        eventBus.subscribe('close-panorama', function () {
          _this2.store.dispatch(setMVKPhaseAction(MVKPhase.PREVIEW));
          _this2.store.dispatch(setPanoramaActiveAction(false));
        });
      }

      // Сохраняем начальный роут для корректной работы роутера
      setTimeout(function () {
        return _this2.store.dispatch(toggleRouteUpdateAction(true));
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        containerStyles = _this$props.containerStyles,
        onClose = _this$props.onClose,
        menuRender = _this$props.menuRender;
      return /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(NewbuildingMVKContainer, {
          containerStyles: containerStyles,
          onClose: onClose,
          menuRender: menuRender
        })
      });
    }
  }]);
  return NewbuildingMVKWidget;
}(React.PureComponent);